import { api } from './client.js';

const root = '/admin/rag';

export const ragApi = {
  stats: () => api.get(`${root}/stats`),
  list: (params) => api.get(`${root}/documents`, { query: params }),
  get: (id) => api.get(`${root}/documents/${id}`),
  upload: (formData) => api.post(`${root}/documents`, formData),
  update: (id, body) => api.patch(`${root}/documents/${id}`, body),
  reindex: (id, formData) => api.post(`${root}/documents/${id}/reindex`, formData),
  remove: (id) => api.delete(`${root}/documents/${id}`),
  listChunks: (id, params) => api.get(`${root}/documents/${id}/chunks`, { query: params }),
  updateChunk: (id, chunkId, body) => api.patch(`${root}/documents/${id}/chunks/${chunkId}`, body),
  deleteChunk: (id, chunkId) => api.delete(`${root}/documents/${id}/chunks/${chunkId}`),
  query: (body) => api.post(`${root}/query`, body)
};
